var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63557 11.6586C1.82123 10.6006 1.41406 10.0717 1.41406 8.50094C1.41406 6.93021 1.82123 6.40123 2.63557 5.34327C4.26158 3.23083 6.98854 0.835938 10.9953 0.835938C15.0021 0.835938 17.729 3.23083 19.3551 5.34327C20.1694 6.40123 20.5766 6.93021 20.5766 8.50094C20.5766 10.0717 20.1694 10.6006 19.3551 11.6586C17.729 13.771 15.0021 16.1659 10.9953 16.1659C6.98854 16.1659 4.26158 13.771 2.63557 11.6586Z",
    stroke: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8738 8.49938C13.8738 10.0868 12.5868 11.3738 10.9994 11.3738C9.4119 11.3738 8.125 10.0868 8.125 8.49938C8.125 6.9119 9.4119 5.625 10.9994 5.625C12.5868 5.625 13.8738 6.9119 13.8738 8.49938Z",
    stroke: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.548a79c6bc8113aeb08721dcdf830ce7.svg";
export { ForwardRef as ReactComponent };